import F30DM1NotFeaturedHomeCardPage from "@faire/prototype-playground/workspace/ar/not-featured-home-card";
import { Route, Switch } from "react-router-dom";

export function AbhishekRaiRoutes() {
  return (
    <Switch>
      <Route
        path="/ar/not-featured-home-card"
        component={F30DM1NotFeaturedHomeCardPage}
      />
    </Switch>
  );
}

export const slug = "ar";
